import { ID_CAPTCHA, USER_ENTERED_CAPTCHA_CODE } from 'utils/consts';
import { encodingUrl, removeTodasMascaras } from 'utils/stringFormatter';

export const formatterProtocoloNull = () => {
  return {
    protocolo: '',
    documento: '',
  };
};

export const formatterProtocoloFrontToBack = dadosInputs => {
  return {
    documento: removeTodasMascaras(dadosInputs.documento),
    localizador: encodingUrl(dadosInputs.protocolo),
    captchaId: localStorage.getItem(ID_CAPTCHA),
    userEnteredCaptchaCode: localStorage.getItem(USER_ENTERED_CAPTCHA_CODE),
  };
};
